import React from "react";
import DataGridStructure from "./datagrid/DataGridStructure";

const Structure = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-center mb-4 text-success ">
        Listes des Structures
      </h1>
      <DataGridStructure />
    </div>
  );
};

export default Structure;
